import styled from "styled-components/macro";

export default styled.div`
${({ theme }) => theme?.colors?.["0"]};
`;
